// Normalize a stored phone string into the digits-only form WhatsApp's
// click-to-chat (https://wa.me/<number>) requires. Returns '' when there
// is nothing usable (null/blank/no digits).
export function toWhatsAppNumber(phone) {
  if (phone == null) return ''
  return String(phone).replace(/\D/g, '')
}
